// src/services/automationService.js
import { api } from './api';
import { objectToQueryString } from '../utils/apiUtils';

// ========================
// Workflows
// ========================

// Get workflows list with pagination and filters
export const getWorkflows = async (projectId, params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/automation/projects/${projectId}/workflows${queryString}`);
};

// Get single workflow by ID
export const getWorkflow = async (workflowId) => {
  return api.get(`/automation/workflows/${workflowId}`);
};

// Create a new workflow
export const createWorkflow = async (projectId, workflowData) => {
  return api.post(`/automation/projects/${projectId}/workflows`, workflowData);
};

// Update an existing workflow
export const updateWorkflow = async (workflowId, workflowData) => {
  return api.put(`/automation/workflows/${workflowId}`, workflowData);
};

// Delete a workflow
export const deleteWorkflow = async (workflowId) => {
  return api.delete(`/automation/workflows/${workflowId}`);
};

// Toggle workflow enabled state
export const toggleWorkflow = async (workflowId, enabled) => {
  return api.patch(`/automation/workflows/${workflowId}/toggle`, { enabled });
};

// Test a workflow
export const testWorkflow = async (workflowId, testData) => {
  return api.post(`/automation/workflows/${workflowId}/test`, testData);
};

// ========================
// Executions
// ========================

// Get workflow executions
export const getExecutions = async (workflowId, params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/automation/workflows/${workflowId}/executions${queryString}`);
};

// Get execution details
export const getExecution = async (executionId) => {
  return api.get(`/automation/executions/${executionId}`);
};

// Cancel an execution
export const cancelExecution = async (executionId) => {
  return api.post(`/automation/executions/${executionId}/cancel`, {});
};

// Retry an execution
export const retryExecution = async (executionId) => {
  return api.post(`/automation/executions/${executionId}/retry`, {});
};

// ========================
// Logs & Monitoring
// ========================

// Get workflow logs
export const getWorkflowLogs = async (workflowId, params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/automation/workflows/${workflowId}/logs${queryString}`);
};

// Get queue status
export const getQueueStatus = async (projectId) => {
  return api.get(`/automation/projects/${projectId}/queue`);
};

// Get analytics
export const getAnalytics = async (projectId, params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/automation/projects/${projectId}/analytics${queryString}`);
};

// ========================
// Import/Export
// ========================

// Export workflow
export const exportWorkflow = async (workflowId) => {
  return api.get(`/automation/workflows/${workflowId}/export`);
};

// Import workflow
export const importWorkflow = async (projectId, workflowData) => {
  return api.post(`/automation/projects/${projectId}/workflows/import`, workflowData);
};

// Default export with all methods
const automationService = {
  // Workflows
  getWorkflows,
  getWorkflow,
  createWorkflow,
  updateWorkflow,
  deleteWorkflow,
  toggleWorkflow,
  testWorkflow,
  
  // Executions
  getExecutions,
  getExecution,
  cancelExecution,
  retryExecution,
  
  // Monitoring
  getWorkflowLogs,
  getQueueStatus,
  getAnalytics,
  
  // Import/Export
  exportWorkflow,
  importWorkflow
};

export default automationService;